import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function MidPageCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-16 bg-[#722F37]" data-id="element-144">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-146">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-147">
            ¿Listo para dejar de pelear y empezar a reconstruir?
          </h2>

          <motion.a href="#cta" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-[#059669] text-white px-8 py-4 rounded-xl text-xl font-bold shadow-[0_10px_25px_-5px_rgba(5,150,105,0.4)] hover:bg-[#047857] transition-colors mb-3" data-id="element-148">
            Obtener producto — $8.900
          </motion.a>

          <p className="text-white/80 text-sm font-medium" data-id="element-149">
            Precio de lanzamiento. No sabemos hasta cuándo.
          </p>
        </motion.div>
      </div>
    </section>;
}